import { AuditMessageDto } from '@app/data/dtos/audit/audit.dto';
import { AuditMessage } from '@app/entities/models/audit/audit.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapAuditMessage: MapFromFn<AuditMessageDto, AuditMessage> = (value) =>
  Builder.forModel(AuditMessage).level(value.level).message(value.message).status_code(value.status_code).build();
